import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { direction_Shrink_str, direction_Swell_str, } from '@zenlayer/zen-design-icons';
import { DateListener, ExportButton, } from '@zenlayer/portal-utils';
import { Button, Chart, Elevation, SvgIcon, Spin } from '@zenlayer/zen-design';
import dayjs from '@zenlayer/zen-design/esm/_util/day';
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
import '@zenlayer/zen-design/esm/chart/style';
import { default as styleJson, default as styleVariables, } from '@zenlayer/zen-design/esm/style/variables/index.json';
import t from '@zenlayer/zen-intl18';
import classNames from 'classnames';
import { useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { ChartDatePicker } from './chartDatePicker';
import { ChartPresetDatePicker, } from './chartPresetDatePicker';
import cls from './index.module.less';
export * from './chartDatePicker';
export * from './chartPresetDatePicker';
export * from './util';
export const dataListener_showUtc = new DateListener('CHARTDATEPICKER_SHOWUTC', { setLocalStorage: true }, undefined);
export const getTimeZone = (showUTCValue) => {
    showUTCValue ?? (showUTCValue = dataListener_showUtc.getValue());
    return showUTCValue ? 'UTC' : dayjs.tz.guess();
};
export const ChartModuleHeader = (props) => {
    const { title, showMore, onExportProps, extraButton, onShrink, onSwell, subTitle, datePickerType = 'datePicker', dataAttrs, ...datePickerProps } = props;
    const showUTCValue = dataListener_showUtc.useValueListener();
    const extra = (_jsxs(_Fragment, { children: [extraButton, showMore && onSwell && (_jsx("a", { onClick: () => {
                    onSwell();
                }, children: t('JFPNAl0R1haK') })), onExportProps && (_jsx(ExportButton, { ...pickDomAttrs(dataAttrs?.export).data, onExportProps: {
                    ...onExportProps,
                    params: {
                        timeZone: getTimeZone(showUTCValue),
                        ...onExportProps.params,
                    },
                } })), onShrink && (_jsx(Button, { ...pickDomAttrs(dataAttrs?.shrink).data, size: "s", type: "normal", onClick: () => {
                    onShrink();
                }, icon: _jsx(SvgIcon, { svgStr: direction_Shrink_str }) })), onSwell && (_jsx(Button, { ...pickDomAttrs(dataAttrs?.swell).data, size: "s", type: "normal", onClick: () => {
                    onSwell();
                }, icon: _jsx(SvgIcon, { svgStr: direction_Swell_str }) }))] }));
    const _title = typeof title === 'function' ? title({ isFullScreen: !!onShrink }) : title;
    const _subTitle = typeof subTitle === 'function'
        ? subTitle({ isFullScreen: !!onShrink })
        : subTitle;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cls.chartModuleHeader, children: [_jsx("div", { className: cls.title, children: _title }), _jsxs("div", { className: cls.extra, children: [datePickerType === 'datePicker' && (_jsx(ChartDatePicker, { ...datePickerProps, extra: extra })), datePickerType === 'presetDatePicker' && (_jsx(ChartPresetDatePicker, { ...datePickerProps, extra: extra }))] })] }), _jsx("div", { children: _subTitle })] }));
};
const getTitleSizeData = (size) => {
    if (size === 's') {
        return '16-20';
    }
    else if (size === 'm') {
        return '18-20';
    }
    else if (size === 'l') {
        return '20-24';
    }
};
const Box = ({ noElevation, elevationType, children, style, className, size, }) => {
    if (noElevation) {
        return (_jsx("div", { className: className, style: style, children: children }));
    }
    return (_jsx(Elevation, { type: elevationType, className: classNames(className, cls[size]), style: style, children: children }));
};
export const ChartModule = (props) => {
    const { title, fullScreen, chartProps, loading = false, legendAutoswitch = true, unusualRender, noElevation, elevationType = 'module', style, className, size = 'm', ...headerProps } = props;
    const showUTCValue = dataListener_showUtc.useValueListener();
    const getChartProps = useCallback(({ isFullScreen = false }) => {
        if (!chartProps) {
            return undefined;
        }
        const _chartProps = typeof chartProps === 'function'
            ? chartProps({ isFullScreen })
            : chartProps;
        let legend = undefined;
        if (_chartProps.legend === undefined) {
            legend = undefined;
        }
        else if (legendAutoswitch) {
            legend = isFullScreen ? _chartProps.legend : true;
        }
        else {
            legend = _chartProps.legend;
        }
        const props = {
            ..._chartProps,
            isUtcTimeZone: showUTCValue,
            height: isFullScreen ? 'calc(100vh - 160px)' : _chartProps.height,
            showDataZoom: _chartProps.showDataZoom === undefined
                ? isFullScreen
                    ? true
                    : false
                : _chartProps.showDataZoom,
            groupId: isFullScreen ? undefined : _chartProps.groupId,
            legend,
            legendScroll: isFullScreen
                ? Math.max(_chartProps.legendScroll || 0, 6)
                : _chartProps.legendScroll,
        };
        return props;
    }, [chartProps, showUTCValue, legendAutoswitch]);
    const showHeader = !!title || !!Object.keys(headerProps).length || !!fullScreen;
    const renderTitle = (data) => {
        return typeof title === 'function' ? title(data) : title;
    };
    function onSwell() {
        const div = document.createElement('div');
        div.style.position = 'fixed';
        div.style.top = '0px';
        div.style.left = '0px';
        div.style.bottom = '0px';
        div.style.right = '0px';
        div.style.width = '100vw';
        div.style.height = '100vh';
        div.style.zIndex = styleVariables['moadl-zIndex'];
        div.style.backgroundColor = styleJson['body-bg'];
        document.body.appendChild(div);
        const root = ReactDOM.createRoot(div);
        const { extraButton, ...availableHeaderProps } = headerProps;
        const _chartProps = getChartProps({ isFullScreen: true });
        root.render(_jsx(Spin, { spinning: loading, children: _jsxs(Elevation, { type: "module", className: cls['l'], style: { width: '100vw', height: '100vh' }, children: [showHeader && (_jsx(ChartModuleHeader, { title: _jsx("div", { className: classNames(cls.inner, cls[`font-l`]), children: renderTitle({ isFullScreen: true }) }), onShrink: () => {
                            root.unmount();
                            document.body.removeChild(div);
                        }, ...availableHeaderProps })), !!_chartProps && _jsx(Chart.MixLineBarChart, { ..._chartProps })] }) }));
    }
    const _chartProps = getChartProps({ isFullScreen: false });
    return (_jsxs(Spin, { spinning: loading, children: [_jsxs(Box, { noElevation: noElevation, elevationType: elevationType, style: { opacity: unusualRender ? 0 : undefined, ...style }, className: className, size: size, children: [showHeader && (_jsx(ChartModuleHeader, { title: _jsx("div", { className: classNames(cls.inner, cls[`font-${size}`]), children: renderTitle({ isFullScreen: false }) }), onSwell: fullScreen && onSwell, ...headerProps })), !!_chartProps && _jsx(Chart.MixLineBarChart, { ..._chartProps })] }), unusualRender && (_jsxs(Box, { noElevation: noElevation, elevationType: elevationType, style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    ...style,
                }, className: className, size: size, children: [showHeader && (_jsx(ChartModuleHeader, { title: _jsx("div", { className: classNames(cls.inner, cls[`font-${size}`]), children: renderTitle({ isFullScreen: false }) }) })), unusualRender] }))] }));
};
